"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButtonGroup = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _computeTestId = require("../../../utils/computeTestId");
var _index = require("../index");
var _RadioButtonGroup = require("./RadioButtonGroup.styles");
var _excluded = ["items", "orientation", "testId", "variant", "label", "disabled", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var RadioButtonGroup = function RadioButtonGroup(props) {
  var items = props.items,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
    testId = props.testId,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'radio' : _props$variant,
    label = props.label,
    disabled = props.disabled,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded);
  var _useStyles = (0, _RadioButtonGroup.useStyles)(),
    root = _useStyles.root,
    horizontal = _useStyles.horizontal;
  var rootTestId = (0, _computeTestId.computeTestId)(testId, 'radio-group');
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": rootTestId,
    className: root
  }, label && /*#__PURE__*/_react["default"].createElement(_core.FormLabel, null, label), /*#__PURE__*/_react["default"].createElement(_core.RadioGroup, _extends({
    className: (0, _classnames["default"])(className, "".concat(orientation === 'horizontal' ? horizontal : ''))
  }, rest), items.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_index.RadioButton, _extends({
      variant: variant,
      key: index
    }, item, {
      disabled: disabled
    }));
  })));
};
exports.RadioButtonGroup = RadioButtonGroup;